








import Table from '@/components/Table.vue';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    Table,
    Header,
    Footer
  }
})
export default class TablePage extends Vue {}
